'use client'

import { ClientLinkPrimary } from 'fukku/Button/ClientLink/Primary'
import { ButtonPrimary } from 'fukku/Button/Primary'
import { cx } from 'utils/cx'
import type { ClientLinkProps } from 'utils/link/client'

import styles from './Action.module.scss'

export interface ActionProps {
	readonly text: JSX.Element | string
	readonly onClick?: (event: React.MouseEvent) => void
	readonly linkAttributes?: Omit<ClientLinkProps, 'children'>
	readonly dataTestId?: string
	readonly className?: string
	readonly isDisabled?: boolean
}
export function Action({
	text,
	onClick,
	linkAttributes,
	dataTestId,
	className,
	isDisabled = false,
}: ActionProps) {
	const { href, withLegacyLocale, linkProps } = linkAttributes ?? {}

	return linkAttributes ? (
		<ClientLinkPrimary
			className={cx(styles.actionBtn, className)}
			data-testid={dataTestId}
			{...(onClick && { onClick })}
			href={href ?? ''}
			withLegacyLocale={withLegacyLocale}
			linkProps={linkProps}
		>
			{text}
		</ClientLinkPrimary>
	) : (
		<ButtonPrimary
			className={cx(styles.actionBtn, className)}
			data-testid={dataTestId}
			disabled={isDisabled}
			{...(onClick && { onClick })}
		>
			{text}
		</ButtonPrimary>
	)
}
